import { render } from "./TvDetailView.vue?vue&type=template&id=4c95379d"
import script from "./TvDetailView.vue?vue&type=script&lang=js"
export * from "./TvDetailView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__